// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

.src-containers-Profile-UnconfirmedEmail-styles--footer--l8a74 {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.src-containers-Profile-UnconfirmedEmail-styles--footer--l8a74 .src-containers-Profile-UnconfirmedEmail-styles--time--LcAJ6 {
    line-height: 20px;
    margin-top: 20px;
    color: #8d96b2;
    color: var(--cloudGray);
  }

@media screen and (min-width: 768px) {

.src-containers-Profile-UnconfirmedEmail-styles--footer--l8a74 .src-containers-Profile-UnconfirmedEmail-styles--time--LcAJ6 {
      line-height: 15px;
  }
    }

@media screen and (max-width: 767.98px) {

.src-containers-Profile-UnconfirmedEmail-styles--footer--l8a74 .src-containers-Profile-UnconfirmedEmail-styles--time--LcAJ6 {
      font-size: 14px;
  }
    }

.src-containers-Profile-UnconfirmedEmail-styles--footer--l8a74 .src-containers-Profile-UnconfirmedEmail-styles--spinner--LHmWh {
    margin-left: 5px;
  }

@media screen and (max-width: 767.98px) {

.src-containers-Profile-UnconfirmedEmail-styles--footer--l8a74 {
    max-width: calc(100vw - 60px);
}
  }

@media screen and (max-width: 767.98px) {
    .src-containers-Profile-UnconfirmedEmail-styles--button--sEPAS > span {
      padding: 0;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin: 0 auto;
      width: calc(100% - 50px);
      display: block;
    }
  }
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/containers/Profile/UnconfirmedEmail/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACpBA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AAuBrB;;AArBE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAuB;IAAvB,uBAAuB;EASzB;;AAPE;;AALF;MAMI,iBAAiB;EAMrB;IALE;;AAEA;;AATF;MAUI,eAAe;EAEnB;IADE;;AAGF;IACE,gBAAgB;EAClB;;AAEA;;AAvBF;IAwBI,6BAA6B;AAEjC;EADE;;AAIA;IACE;MACE,UAAU;MACV,mBAAmB;MACnB,uBAAuB;MACvB,cAAc;MACd,wBAAwB;MACxB,cAAc;IAChB;EACF","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\n.footer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  & .time {\n    line-height: 20px;\n    margin-top: 20px;\n    color: var(--cloudGray);\n\n    @media (--desktop) {\n      line-height: 15px;\n    }\n\n    @media (--mobile) {\n      font-size: 14px;\n    }\n  }\n\n  & .spinner {\n    margin-left: 5px;\n  }\n\n  @media (--mobile) {\n    max-width: calc(100vw - 60px);\n  }\n}\n\n.button {\n  @media (--mobile) {\n    & > span {\n      padding: 0;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      margin: 0 auto;\n      width: calc(100% - 50px);\n      display: block;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `src-containers-Profile-UnconfirmedEmail-styles--footer--l8a74`,
	"time": `src-containers-Profile-UnconfirmedEmail-styles--time--LcAJ6`,
	"spinner": `src-containers-Profile-UnconfirmedEmail-styles--spinner--LHmWh`,
	"button": `src-containers-Profile-UnconfirmedEmail-styles--button--sEPAS`
};
module.exports = ___CSS_LOADER_EXPORT___;
